import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { XCircle, ArrowLeft } from "lucide-react";
import { Nav, Footer } from "@/components/Nav";
import { useLang } from "@/i18n/LanguageContext";

export default function PaymentCancel() {
    const { t } = useLang();
    const [releaseMessage, setReleaseMessage] = useState("");
    const [params] = useSearchParams();
    const session = params.get("session_id");
    const [retry, setRetry] = useState(0);
    const [retryable, setRetryable] = useState(false);
    const cancelRequest = useRef(null);
    useEffect(() => {
        let active = true;
        if (session) {
            setRetryable(false);
            setReleaseMessage("Chiusura della prenotazione temporanea…");
            const key = `${session}:${retry}`;
            if (cancelRequest.current?.key !== key) cancelRequest.current = { key, promise: api.post("/payments/cancel", { session_id: session }) };
            cancelRequest.current.promise.then(() => { if (active) setReleaseMessage("Posto nuovamente disponibile. Nessun pagamento effettuato."); })
                .catch(e => { if (active) { setReleaseMessage(e?.response?.data?.detail || "Verifica della sessione non disponibile"); setRetryable(!e?.response || e.response.status >= 500); } });
        }
        return () => { active = false; };
    }, [session, retry]);
    return (
        <div className="min-h-screen bg-[#15181C] text-[#F4F2ED]">
            <Nav />
            <div className="max-w-2xl mx-auto px-5 md:px-8 py-24 text-center">
                <XCircle className="mx-auto text-[#9AA2AD] mb-6" size={72} strokeWidth={1.5} />
                <h1 data-testid="cancel-title" className="font-display text-5xl uppercase mb-3">{t("cancel.title")}</h1>
                <p className="text-[#9AA2AD] mb-8">{t("cancel.body")}</p>
                {releaseMessage && <p data-testid="cancel-release-status" role="status" className="text-sm text-[#9AA2AD] mb-5">{releaseMessage}</p>}
                {retryable && <button data-testid="cancel-release-retry" onClick={() => setRetry(n => n + 1)} className="border border-[#9AA2AD]/30 px-4 py-2 mb-5 hover:border-[#E2231A] text-sm transition-colors">Riprova annullamento</button>}
                <Link to="/#prodotti" data-testid="cancel-retry" className="inline-flex items-center gap-2 bg-[#E2231A] hover:bg-[#C11B15] px-6 py-3 font-display text-xl uppercase tracking-wider transition-colors duration-150">
                    <ArrowLeft size={18} /> {t("cancel.back")}
                </Link>
            </div>
            <Footer />
        </div>
    );
}
